module.exports = __webpack_public_path__ + "static/img/8.87ea2b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/sp/8.png
// module id = 4SIv
// module chunks = 0